import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    token:'',
    adminlist:[],
    island:false,
    lang:window.localStorage.lang
  },
  mutations:{
    adminlogin(val,state){
      val.token = state.token;
      val.adminlist = []
      let arr = []
      state.roles.map(ev=>{
        arr.push(ev.role)
      })
      val.adminlist = arr

      localStorage.setItem('adminlist', JSON.stringify(arr));
    },
    upisland(state,val){
      state['island'] = val
      // console.log(val,state)
    }
  },
  actions:{},
  modules:{}
})



// WEBPACK FOOTER //
// ./src/store/index.js